import TooltipContent from './tooltip-content.component';
export default TooltipContent;
